module.exports = __webpack_public_path__ + "img/3-removebg-preview.002399b8.png";